<template>
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-8">
          <h4 class="mb-4">{{ flowRef?.step === 1 ? 'Select Platform' : 'Add Order' }}</h4>
      </div>
      <div class="col-12 col-lg-8">
        <create-order-flow
          ref="flowRef"
          :prefill-items="prefillItems"
          @saved="onSaved"
        />
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-lg-8">
        <div class="d-grid gap-3 mt-3">
          <button class="btn btn-outline-secondary" @click="cancel">
            <i class="bi bi-x-lg"></i> Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import CreateOrderFlow from '@/app/components/orders/CreateOrderFlow.vue'

const router = useRouter()
const flowRef = ref(null)

const prefillItems = computed(() =>
  history.state?.prefillItem ? [history.state.prefillItem] : null
)

function cancel() {
  router.back()
}

function onSaved() {
  router.push({ name: 'NewOrders' })
}


onBeforeRouteLeave((to, from, next) => {
  if (flowRef.value?.step === 2) {
    if (!confirm('Leave without saving? Your order data will be lost.')) {
      next(false)
      return
    }
  }
  next()
})
</script>
